exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.LoadingPictureContainer {\n    z-index: 10000;\n    position: absolute;\n    display: inline-block;\n}\n", ""]);

// exports
